import { classNames } from "shared/lib/classNames/classNames";
import cls from "./Paragraph.module.scss";
import {HTMLAttributes} from "react";

export enum ParagraphTheme {
    ALIGN_LEFT = "left",
    ALIGN_RIGHT = "right",
    NEUTRAL = "neutral",
    BRIGHT = "bright"
}

export interface ParagraphProps extends HTMLAttributes<HTMLParagraphElement> {
    className?: string;
    theme?: ParagraphTheme;
}

const Paragraph = ({ className, theme = ParagraphTheme.ALIGN_LEFT, children, ...rest }: ParagraphProps) => {
    return (
        <p {...rest} className={classNames(cls.Paragraph, {}, [className, cls[theme]])}>
            {children}
        </p>
    )
};

export default Paragraph;



